<template>
  <app-loading :loading="loading">
    <div class="all">
      <h2>{{ $store.getters['user/data'].id }}</h2>
      <router-link :to="`/dashboard/farms/map-view`">BACK</router-link>
      <app-btn @click="go">CLICK</app-btn>
      <app-btn @click="purgeCustomerWithPlan">Purge Stripe customer data</app-btn>
      <app-btn @click="connectToStripe">Connect to stripe</app-btn>

      <div class="content">

        <app-btn @click="$store.commit('user/changeTheme', 'default')">Default mode</app-btn>
        <app-btn @click="$store.commit('user/changeTheme', 'dark')">dark mode</app-btn>
        <app-btn @click="$store.commit('user/changeTheme', 'cursed')">Cursed mode</app-btn>

      </div>
    </div>
  </app-loading>
</template>

<script>
export default {
  data() {
    return {
      // interpretation: 0,
      loading: false,
    }
  },
  methods: {
    go() {
      this.$config.API.post('/verde/tmp/test');
    },

    // changeTheme(val) {
    //   this.$store.commit('user/changeTheme', val);
    // },

    connectToStripe() {
      this.loading = true;
      this.$config.API.put('/user/connect/stripe')
        .finally(() => {
          this.loading = false;
        });
    },

    purgeCustomerWithPlan() {
      this.loading = true;
      this.$config.API.delete('/plan/purge')
        .finally(() => {
          this.loading = false;
        });
    }
  }
}
</script>

<style lang="scss" scoped>

.all {
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  > * {
    margin: 20px 0;
  }
}

.content {
  display: flex;
  align-items: center;
  justify-content: center;
  > * {
    margin: 0 8px;
  }
}
</style>
